<template>
  <div class="fm-content">
    <!-- 列表项 -->
    <!-- 最新动态 -->
    <div class="newHead" v-if="isUser">
      <div class="rightBox" @click="closeUser">
        <svg-btn class="leftIcon" icon-class="icon-close"></svg-btn>
      </div>
      <div class="centerFont">最新动态</div>
      <div class="rightFont" @click="toUser(arrList[0])">个人主页</div>
    </div>
    <div
      class="Box"
      v-for="(item, index) in arrList"
      :key="item.id || index"
      :data-index="index"
      :class="{ visible: item.visible }"
      ref="boxElements"
    >
      <div class="content">
        <!-- 头部区域 -->
        <div class="BoxHead">
          <div class="headLeft">
            <el-image
              @click="toUser(item)"
              :src="item.logo"
              fit="cover"
              class="headImg"
            >
              <img
                width="40"
                height="40"
                slot="error"
                @click="toUser(item)"
                class="error-headImg"
                :src="$utils.getPng('icon-gfans-defaultHead')"
              />
            </el-image>
            <div class="info">
              <div class="infoBox">
                <div class="font1" @click="toUser(item)">
                  {{ item.nickname }}
                </div>
                <div v-show="item.is_top == 1" class="topBox">置顶</div>
              </div>
              <div class="font2">{{ item.in_time }}</div>
            </div>
          </div>
          <div class="headright">
            <div
              v-show="isFind && item.is_follow != -1 && isType != 3"
              @click="checkDy(item, index)"
              :class="{
                releaseBtn: true,
                primaryBtn: item.is_follow == 0,
                releaseBtn2: item.is_follow == 1,
                textBtn: item.is_follow == 1,
              }"
            >
              {{ item.is_follow == 1 ? '已订阅' : '订阅' }}
            </div>
            <ClickPop class="ClickPop" v-show="item.is_follow != -1">
              <div class="moreBox">
                <svg-btn class="more" icon-class="icon-gfans-more"></svg-btn>
              </div>
              <div slot="content" class="arrCheck">
                <div
                  class="check"
                  @click="check(item, itn.id)"
                  v-for="(itn, idx) in item.is_follow == 1
                    ? checkList
                    : checkList2"
                  :key="idx"
                >
                  <svg-btn
                    class="moreIcon"
                    :icon-class="'icon-gfans-more' + itn.id"
                  ></svg-btn>
                  <span class="font3">{{ itn.name }}</span>
                </div>
              </div>
            </ClickPop>
          </div>
        </div>

        <div class="BoxOne" @click="goDetail(item)">
          {{ item.name }}
        </div>

        <div class="BoxTwo" @click="goDetail(item)">
          <!-- 占位容器-->
          <div
            ref="imageWrapper"
            :class="{
              'image-wrapper': true,
              // isNone: item.imageError || item.cover_is_error == 1,
            }"
            :data-index="index"
            :style="{
              width: item.cover_width + 'px',
              height: item.cover_height + 'px',
            }"
          >
            <!-- 模糊占位符 - 显示低质量thumb图 -->
            <div
              class="blur-placeholder"
              :class="{
                'fade-out': item.imageLoaded || item.imageError,
                // isNone: item.imageError || item.cover_is_error == 1,
              }"
              :style="{
                width: '100%',
                height: '100%',
                ...item.blurStyle,
              }"
            >
              <img :src="item.thumb" alt="" class="placeholder-img" />
            </div>

            <!-- 图片容器 - 显示高质量cover图 -->
            <div
              class="image-container"
              :style="{
                width: '100%',
                height: '100%',
                opacity: item.imageLoaded ? 1 : 0,
              }"
            >
              <el-image
                ref="imgElements"
                :src="item.cover"
                :fit="'cover'"
                class="img"
                lazy
                @load="handleImageLoad(item, index)"
                @error="handleImageError(item, index)"
              ></el-image>
              <!-- Stop 按钮 -->
              <div class="stop" v-show="item.stype == 2 && item.imageLoaded">
                <svg-btn
                  class="stopIcon"
                  icon-class="icon-video-stop"
                ></svg-btn>
              </div>
            </div>
          </div>

          <!-- 加载失败 -->
          <div
            class="load-fail"
            :style="{
              width: item.cover_width + 'px',
              height: item.cover_height + 'px',
            }"
            v-show="item.imageError || item.cover_is_error == 1"
          >
            <svg-btn
              v-if="item.imageError"
              class="failIcon"
              :icon-class="
                item.stype == 2 ? 'icon-gfans-videoNo' : 'icon-gfans-imgNo'
              "
            />
            <svg-btn
              v-if="item.cover_is_error == 1"
              class="failIcon"
              :icon-class="
                item.stype == 2 ? 'icon-gfans-videoWg' : 'icon-gfans-imgWg'
              "
            />
          </div>
        </div>
        <!-- 描述 -->
        <div @click="goDetail(item)" class="htmlBox2" v-html="item.vhtml"></div>
        <!-- 文件/合集/附件 -->
        <div
          class="BoxFour"
          v-show="item.file_attachment.length > 0"
          @click="goDetail(item)"
        >
          <div
            class="four"
            v-for="(itn, idx) in item.file_attachment"
            :key="idx"
          >
            <div class="fourLeft">
              <svg-btn
                class="btIcon"
                :icon-class="
                  itn.stype == 1
                    ? 'icon-gfans-wj'
                    : itn.stype == 2
                    ? 'icon-gfans-hj'
                    : 'icon-gfans-fj'
                "
              ></svg-btn>
              <div class="fourFont">{{ itn.name }}</div>
            </div>
            <svg-btn class="rightIcon" icon-class="icon-right"></svg-btn>
          </div>
        </div>
        <div class="BoxFive">
          <!-- 点赞按钮 -->
          <div class="btBox" @click="checkUp(item, index)">
            <svg-btn
              :class="{
                btIcon: true,
                font5: item.is_like == 1,
              }"
              :icon-class="item.is_like == 1 ? 'icon-up-x' : 'icon-up'"
            ></svg-btn>
            <div :class="['font4', { font5: item.is_like == 1 }]">
              {{ $utils.formatNumber(item.good_num) }}
            </div>
          </div>
          <!-- 收藏按钮 -->
          <div class="btBox" @click="checkCollect(item, index)">
            <svg-btn
              :class="{
                btIcon: true,
                font5: item.is_collect == 1,
              }"
              :icon-class="
                item.is_collect == 1 ? 'icon-collect-x' : 'icon-collect'
              "
            ></svg-btn>
            <div :class="['font4', { font5: item.is_collect == 1 }]">
              {{ $utils.formatNumber(item.save_num) }}
            </div>
          </div>
          <!-- 评论按钮 -->
          <div class="btBox" @click="toComment(item)">
            <svg-btn class="btIcon" icon-class="icon-comment"></svg-btn>
            <div class="font4">
              {{ $utils.formatNumber(item.comment_num) }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 新增：加载更多触发元素（位于列表末尾） -->
    <div ref="loadMoreTrigger" class="load-more-trigger"></div>
    <!-- 底部加载状态 -->
    <div class="loadStatus" v-if="arrList.length">
      <div v-if="isLoading" id="loadBoxId" class="loadBox">
        <div class="spinner"></div>
        <span class="not">加载中</span>
      </div>
      <div class="not" v-show="noMoreData">没有更多了</div>
    </div>
    <PromptTip
      @confirm="confirm"
      @handleClose="handleClose"
      :tips="tips"
      :isShow="isShow"
    />
    <report
      :stype="stype"
      :id="id"
      @handleClose="reportShow = false"
      :isShow="reportShow"
    />
  </div>
</template>

<script>
import { checkModirlt, checkLike, checkCollec } from '@/axios/home'
import ClickPop from '@/components/ClickPop/index'
import PromptTip from '@/components/PromptTip/index'
import report from '@/components/report/index'
import { eventBus } from '@/utils/event-bus'
export default {
  components: {
    ClickPop,
    PromptTip,
    report,
  },
  props: {
    //数组
    arrList: { type: Array, required: true, default: () => [] },
    //是否还在加载
    isLoading: {
      type: Boolean,
      default: false,
    },
    //是否没有更多了
    noMoreData: {
      type: Boolean,
      default: false,
    },
    //是否是个人主页
    isUser: {
      type: Boolean,
      default: false,
    },
    //是否是发现页面
    isFind: {
      type: Boolean,
      default: false,
    },
    //1是首页组件 2是我的订阅组件 3是个人中心组件
    isType: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      checkList: [
        {
          id: 1,
          name: '取消订阅',
        },
        {
          id: 2,
          name: '举报',
        },
      ],
      checkList2: [
        {
          id: 2,
          name: '举报',
        },
      ],
      firstScreenCount: 3, //首屏加载数
      visibilityObserver: null, // 列表项可见性观察器
      loadMoreObserver: null, // 加载触发观察器
      loadMoreDistance: 200, // 距离底部多少像素触发加载
      initialized: false, // 标记初始渲染完成
      imagePreloadDistance: 800, // 提前800px预加载
      imageObserver: null,
      imageWrapperReady: false, // 标记图片容器准备状态
      isShow: false, //消息提示
      reportShow: false, //举报弹窗
      tips: '', //弹窗文案
      uid: '', //用户id
      stype: '',
      file_id: '',
      showType: '', //dy是取消订阅 sc是取消收藏
      scIndex: '', //收藏选中的下标
      id: '', //帖子id
    }
  },
  created() {
    // 初始化数据状态，添加图片相关属性 注释是因为这些值由后端返回过来
    // this.arrList.forEach(item => {
    //   this.$set(item, 'visible', false)
    //   this.$set(item, 'imageLoaded', false)
    //   this.$set(item, 'imageError', false)
    //   this.$set(item, 'blurStyle', 'filter: blur(15px)') // 初始模糊度，使用filter属性
    // })
  },
  mounted() {
    this.setFirstScreenVisible()
    this.$nextTick(() => {
      setTimeout(() => {
        this.setupImagePreloadObserver()
        this.setupVisibilityObserver() // 设置列表项可见性观察
        this.setupLoadMoreObserver() // 设置加载触发观察
        this.initialized = true // 初始渲染完成
      }, 300) // 减少延迟，更快初始化
    })
  },
  beforeUnmount() {
    this.visibilityObserver?.disconnect()
    this.loadMoreObserver?.disconnect()
    this.imageObserver?.disconnect()
    // 清理未完成的图片加载
    this.arrList.forEach(item => {
      item.imageLoaded = false
    })
    // 清空引用
    this.visibilityObserver = null
    this.loadMoreObserver = null
    this.imageObserver = null
  },
  watch: {
    // 监听 arrList 变化
    arrList: {
      deep: true,
      handler(newVal, oldVal) {
        if (!this.initialized) return // 跳过初始渲染
        this.$nextTick(() => {
          // 确保DOM已更新
          this.checkCachedImages() // 检查缓存图片
        })
        this.handleNewData(newVal, oldVal)
      },
    },
  },
  methods: {
    //跳转个人中心
    toUser: _.debounce(
      function (item) {
        if (this.$store.state.isLogin == 0) {
          eventBus.$emit('showLogin', {})
          return
        }
        const route = this.$router.resolve({
          name: 'user',
          params: { uid: item.userid },
        })
        // 使用解析后的 href 打开新窗口
        window.open(route.href, '_blank')
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //跳转帖子详情页
    goDetail: _.debounce(
      function (item) {
        //stype为1是文章，2是视频
        const routeName = item.stype == 1 ? 'jx' : 'vd'
        this.$router.push({
          name: routeName,
          params: { id: item.fshort },
          query: {
            isType: this.isType,
          },
        })
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //跳转帖子详情页 定位评论区
    toComment: _.debounce(
      function (item) {
        const routeName = item.stype == 1 ? 'jx' : 'vd'
        this.$router.push({
          name: routeName,
          params: { id: item.fshort },
          query: {
            with_cthis: -1,
            isType: this.isType,
          },
        })
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    setupImagePreloadObserver() {
      if (!('IntersectionObserver' in window)) return

      this.$nextTick(() => {
        const wrappers = Array.from(this.$refs.imageWrapper || [])
        if (wrappers.length === 0) return

        this.imageObserver = new IntersectionObserver(
          entries => {
            entries.forEach(entry => {
              const index = parseInt(entry.target.dataset.index)
              const item = this.arrList[index]
              if (entry.isIntersecting && !item.imageLoaded) {
                this.preloadImage(item.cover) // 预加载高质量图
                this.imageObserver.unobserve(entry.target)
              }
            })
          },
          {
            rootMargin: `0px 0px ${this.imagePreloadDistance}px 0px`,
            threshold: 0.1, // 元素10%可见即触发
          }
        )

        wrappers.forEach((wrapper, index) => {
          wrapper.dataset.index = index
          this.imageObserver.observe(wrapper)
        })
        this.imageWrapperReady = true
      })
    },
    preloadImage(url) {
      if (!url) return
      const img = new Image()
      img.src = url
    },
    //handleNewData 方法，使用 requestAnimationFrame 批量更新
    handleNewData(newList, oldList) {
      if (!newList || newList.length === 0) return

      const newItemsCount = newList.length - oldList.length
      if (newItemsCount <= 0) return

      // 使用 requestAnimationFrame 确保浏览器在下一帧批量处理更新
      requestAnimationFrame(() => {
        this.$nextTick(() => {
          for (let i = oldList.length; i < newList.length; i++) {
            this.$set(this.arrList[i], 'visible', true)
          }
        })
      })
    },
    setFirstScreenVisible() {
      const count = Math.min(this.arrList.length, this.firstScreenCount)
      for (let i = 0; i < count; i++) {
        this.$set(this.arrList[i], 'visible', true)
        this.preloadImage(this.arrList[i].cover) // 预加载首屏图片
      }
    },
    setupVisibilityObserver() {
      if (!('IntersectionObserver' in window)) return

      const elements = this.$refs.boxElements || []
      if (elements.length === 0) return

      this.visibilityObserver = new IntersectionObserver(
        entries => {
          // 批量处理可见性变化，使用 requestAnimationFrame 延迟更新
          if (entries.length) {
            requestAnimationFrame(() => {
              entries.forEach(entry => {
                const index = parseInt(entry.target.dataset.index)
                if (this.isValidIndex(index) && !this.arrList[index].visible) {
                  this.$set(this.arrList[index], 'visible', true)
                  this.preloadImage(this.arrList[index].cover)
                  this.visibilityObserver.unobserve(entry.target)
                }
              })
            })
          }
        },
        {
          rootMargin: '200px 0px', // 保持预加载距离
          threshold: 0.1, // 元素10%可见即触发，减少精确计算
        }
      )

      // 初始化观察
      elements.forEach(el => {
        const index = parseInt(el.dataset.index)
        if (el && !this.arrList[index].visible) {
          this.visibilityObserver.observe(el)
        }
      })
    },

    // setupLoadMoreObserver方法优化
    setupLoadMoreObserver() {
      if (!('IntersectionObserver' in window)) return

      const trigger = this.$refs.loadMoreTrigger
      if (!trigger) return

      let loadMoreThrottle = false

      this.loadMoreObserver = new IntersectionObserver(
        entries => {
          // 处理所有可见性变化的条目
          entries.forEach(entry => {
            if (
              entry.isIntersecting &&
              !this.noMoreData &&
              !this.isLoading &&
              !loadMoreThrottle
            ) {
              loadMoreThrottle = true
              requestAnimationFrame(() => {
                this.$emit('load-more')
                setTimeout(() => {
                  loadMoreThrottle = false
                }, 300) // 300ms内只触发一次加载
              })
            }
          })
        },
        {
          rootMargin: `0px 0px ${this.loadMoreDistance}px 0px`,
          threshold: 0.1, // 元素10%可见即触发
        }
      )

      this.loadMoreObserver.observe(trigger)
    },

    // 处理图片加载完成
    handleImageLoad(item, index) {
      this.$set(item, 'imageLoaded', true)
      this.$set(item, 'imageError', false)
      this.$set(item, 'blurStyle', 'blur(0px)') // 移除模糊效果
    },

    handleImageError(item, index) {
      this.$set(item, 'imageError', true)
      this.$set(item, 'imageLoaded', false)
      this.$set(item, 'blurStyle', 'blur(0px)') // 错误时也移除模糊
    },
    // 检查缓存的图片，手动触发加载完成
    checkCachedImages() {
      // 获取所有图片元素（el-image内部的img标签）
      const imgElements = this.$refs.imgElements || []
      // 处理单个图片元素的情况（非数组）
      const images = Array.isArray(imgElements) ? imgElements : [imgElements]

      images.forEach((elImage, index) => {
        if (!elImage) return
        // 获取el-image内部的原生img元素
        const img = elImage.$el.querySelector('img')
        if (!img) return

        // 获取当前图片对应的item数据
        const item = this.arrList[index]
        if (!item) return

        // 关键：如果图片已加载（来自缓存）但状态未更新，手动触发加载完成
        if (img.complete && !item.imageLoaded && !item.imageError) {
          this.handleImageLoad(item, index) // 手动调用加载完成逻辑
        }
      })
    },
    closeUser() {
      this.$emit('closeUser')
    },
    // 其他方法保持不变
    isValidIndex(index) {
      return !isNaN(index) && index >= 0 && index < this.arrList.length
    },
    check(row, idx) {
      if (idx == 1) {
        //点击取消订阅
        this.uid = row.userid
        this.showType = 'dy'
        this.tips = '确认取消订阅该订阅号？'
        this.isShow = true
      } else {
        this.stype = row.stype
        this.id = row.file_id
        this.reportShow = true
      }
    },
    //点击订阅
    checkDy: _.debounce(
      function (item, index) {
        if (this.$store.state.isLogin == 0) {
          eventBus.$emit('showLogin', {})
          return
        }
        let is_follow = this.$utils.checkNum(this.arrList[index].is_follow)
        if (is_follow == 0) {
          this.uid = item.userid
          this.showType = 'dy'
          this.tips = '确认取消订阅该订阅号？'
          this.isShow = true
          return
        }
        let data = {
          uid: item.userid,
          act: 1,
        }
        checkModirlt(data).then(res => {
          if (res.status == 1) {
            this.frontEndUp(item.userid)
            //如果是个人主页需要更新主页数据
            if (this.$route.name == 'user') {
              this.$emit('updataUp')
            }
            eventBus.$emit('upHotList')
            this.$toast(res.msg, 1)
          } else {
            this.$toast(res.msg, 2)
          }
        })
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    // 前端处理的订阅逻辑 给父组件调用 更新子组件状态
    frontEndUp(id) {
      //遍历所有符合当前用户uid的数据
      for (let i = this.arrList.length - 1; i >= 0; i--) {
        if (this.arrList[i].userid == id) {
          this.arrList[i].is_follow = this.$utils.checkNum(
            this.arrList[i].is_follow
          )
        }
      }
    },
    //取消订阅 取消收藏
    confirm: _.debounce(
      function () {
        if (this.showType == 'dy') {
          //取消订阅
          this.confirmDy()
        } else if (this.showType == 'sc') {
          //取消收藏
          this.confirmSc()
        } else {
          //极限情况，直接关闭弹窗
          this.handleClose()
        }
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //弹窗取消订阅方法
    confirmDy() {
      checkModirlt({
        uid: this.uid,
        act: 2,
      }).then(res => {
        if (res.status == 1) {
          //遍历所有符合当前用户uid的数据
          this.frontEndUp(this.uid)
          //如果是我的订阅列表需要从列表里面逻辑删除取消订阅数据
          if (this.$route.name == 'subscribe') {
            // 必须删除原数组元素
            for (let i = this.arrList.length - 1; i >= 0; i--) {
              if (this.arrList[i].userid == this.uid) {
                this.arrList.splice(i, 1)
              }
            }
            //如果是在个人主页点击取消订阅需要手动去子组件删除那条数据,并且刷新页面
            //如果传递false，代表不是在个人主页点的，不需要刷新页面，只需要删除那条数据
            if (this.isUser) {
              this.$emit('closeUser', this.uid, true)
            } else {
              this.$emit('closeUser', this.uid, false)
            }
          }
          //如果是个人主页需要更新主页数据
          if (this.$route.name == 'user') {
            this.$emit('updataUp')
          }
          eventBus.$emit('upHotList')
          this.handleClose()
          this.$toast(res.msg, 1)
        } else {
          this.$toast(res.msg, 2)
        }
      })
    },
    //弹窗取消收藏方法
    confirmSc() {
      checkCollec({
        type: this.stype,
        is_collect: 0,
        post_id: this.file_id,
      }).then(res => {
        if (res.status == 1) {
          this.arrList[this.scIndex].is_collect = this.$utils.checkNum(
            this.arrList[this.scIndex].is_collect
          )
          //如果是个人主页需要更新主页数据
          if (this.$route.name == 'user') {
            this.$emit('updataUp')
          }
          if (this.arrList[this.scIndex].save_num > 0) {
            this.arrList[this.scIndex].save_num--
          }
          this.updateHomePage({
            fshort: this.arrList[this.scIndex].fshort,
            is_collect: this.arrList[this.scIndex].is_collect,
            save_num: this.arrList[this.scIndex].save_num,
          })
          this.handleClose()
          this.$toast(res.msg, 1)
        } else {
          this.$toast(res.msg, 2)
        }
      })
    },
    //关闭取消订阅弹窗
    handleClose() {
      this.stype = ''
      this.file_id = ''
      this.uid = ''
      this.act = ''
      this.showType = ''
      this.scIndex = ''
      this.isShow = false
    },
    //点赞
    checkUp: _.debounce(
      function (item, index) {
        if (this.$store.state.isLogin == 0) {
          eventBus.$emit('showLogin', {})
          return
        }
        let data = {
          id: item.file_id,
          type: item.stype,
          is_like: item.is_like == 0 ? 1 : 0,
        }
        checkLike(data).then(res => {
          if (res.status == 1) {
            this.arrList[index].is_like = this.$utils.checkNum(
              this.arrList[index].is_like
            )
            //如果是个人主页需要更新主页数据
            if (this.$route.name == 'user') {
              this.$emit('updataUp')
            }
            if (this.arrList[index].is_like == 1) {
              this.arrList[index].good_num++
            } else {
              if (this.arrList[index].good_num > 0) {
                this.arrList[index].good_num--
              }
            }
            this.updateHomePage({
              fshort: this.arrList[index].fshort,
              is_like: this.arrList[index].is_like,
              good_num: this.arrList[index].good_num,
            })
          } else {
            this.$toast(res.msg, 2)
          }
        })
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),

    //收藏
    checkCollect: _.debounce(
      function (item, index) {
        if (this.$store.state.isLogin == 0) {
          eventBus.$emit('showLogin', {})
          return
        }
        if (item.is_collect == 1) {
          this.stype = item.stype
          this.file_id = item.file_id
          this.scIndex = index
          this.showType = 'sc'
          this.tips = '确定取消收藏该帖子？'
          this.isShow = true
          return
        }
        checkCollec({
          type: item.stype,
          is_collect: 1,
          post_id: item.file_id,
        }).then(res => {
          if (res.status == 1) {
            this.arrList[index].is_collect = this.$utils.checkNum(
              this.arrList[index].is_collect
            )
            //如果是个人主页需要更新主页数据
            if (this.$route.name == 'user') {
              this.$emit('updataUp')
            }
            this.arrList[index].save_num++
            this.updateHomePage({
              fshort: this.arrList[index].fshort,
              is_collect: this.arrList[index].is_collect,
              save_num: this.arrList[index].save_num,
            })
            this.$toast(res.msg, 1)
          } else {
            this.$toast(res.msg, 2)
          }
        })
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    // 批量更新多个字段并通知返回页
    updateHomePage(updatedFields) {
      // 合并需要更新的字段
      const dataToUpdate = {
        fshort: updatedFields.fshort,
        ...updatedFields,
      }

      // 发送事件通知页面更新
      eventBus.$emit('itemUpdated', dataToUpdate)
    },
  },
}
</script>

<style lang="scss" scoped>
.fm-content {
  border-radius: 16px 16px 0px 0px;
  height: 100%;
  overflow: hidden;
  @include useTheme {
    background: getVar('bg-color-content');
  }
}
.newHead {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px 14px 11px;
  .rightBox {
    padding: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 5px;
    @include useTheme {
      color: getVar('text-color7-90969c');
    }
    &:hover {
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }
    .leftIcon {
      width: 16px;
      height: 16px;
    }
  }
  .centerFont {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    @include useTheme {
      color: getVar('text-color1-2c2c2c');
    }
  }
  .rightFont {
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    cursor: pointer;
    @include useTheme {
      color: getVar('text-color3-90969c');
    }
  }
}
.Box {
  will-change: transform, opacity;
  contain: layout;
  transform: translateZ(0);
  transition: opacity 0.3s ease-out, transform 0.3s ease-out;
  padding: 16px 16px 0 16px;
  opacity: 0;
  @include useTheme {
    box-shadow: inset 0px -1px 0px 0px getVar('border-color2-f2f4f6');
  }
  &.visible {
    opacity: 1;
  }
  .BoxHead {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1px 0;
    margin-bottom: 16px;

    .headLeft {
      display: flex;
      align-items: center;
      margin-right: 16px;

      .avatar-container {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        overflow: hidden;
      }

      .headImg {
        width: 40px;
        height: 40px;
        object-fit: cover;
        border-radius: 50%;
        flex-shrink: 0;
        cursor: pointer;
      }
      .info {
        display: flex;
        flex-direction: column;
        margin-left: 12px;
        .infoBox {
          display: flex;
          align-items: center;
          .font1 {
            font-weight: 500;
            font-size: 14px;
            line-height: 22px;
            max-width: 382px;
            cursor: pointer;
            @include multiline(1);
            @include useTheme {
              color: getVar('text-color1-2c2c2c');
            }
          }
          .topBox {
            margin-left: 6px;
            margin-top: 2px;
            border-radius: 13px;
            padding: 0 6px;
            font-weight: 400;
            font-size: 12px;
            color: #ffffff;
            line-height: 18px;
            flex-shrink: 0;
            @include useTheme {
              background: getVar('primary-color');
            }
          }
        }
        .font2 {
          font-weight: 400;
          font-size: 12px;
          line-height: 18px;
          @include useTheme {
            color: getVar('text-color3-90969c');
          }
        }
      }
    }
    .headright {
      display: flex;
      align-items: center;
      .moreBox {
        cursor: pointer;
        border-radius: 5px;
        width: 28px;
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        @include useTheme {
          color: getVar('text-color7-90969c');
        }
        .more {
          width: 16px;
          height: 16px;
        }
        &:hover {
          @include useTheme {
            background: getVar('bg-color1-f4f6f8');
          }
        }
      }
      .releaseBtn {
        padding: 5px 23px;
        height: 32px;
        border-radius: 18px;
        font-weight: 500;
        font-size: 14px;
        color: #ffffff;
        line-height: 22px;
        margin-right: 16px;
        flex-shrink: 0;
      }
      .releaseBtn2 {
        padding: 0 !important;
        width: 74px !important;
        @include useTheme {
          color: getVar('text-color2-75787b');
        }
      }
    }
  }

  .BoxOne {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    max-width: 568px;
    margin-bottom: 12px;
    cursor: pointer;
    @include multiline(2);
    @include useTheme {
      color: getVar('text-color1-2c2c2c');
    }
  }

  .BoxTwo {
    width: 100%;
    height: auto;
    border-radius: 16px;
    margin-bottom: 12px;
    position: relative;
    will-change: transform, opacity;
    contain: layout;
    transform: translateZ(0);
    backface-visibility: hidden;
    transition: opacity 0.3s ease-out, transform 0.3s ease-out;
    cursor: pointer;
    .image-wrapper {
      position: relative;
      contain: strict;
      display: block;
      width: 100%;
      max-width: 100%;
      height: auto;
      will-change: height, contents;
      contain: layout;
      position: relative;
      .blur-placeholder {
        position: absolute; // 保持绝对定位以叠加在图片上
        top: 0;
        left: 0;
        width: auto;
        max-width: 100%;
        height: 100%;
        z-index: 2; /* 确保在图片上方 */
        display: flex;
        align-items: center;
        justify-content: center;
        transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        border-radius: 16px;
        overflow: hidden;
        @include useTheme {
          background: getVar('bg-color-content');
        }
        &.fade-out {
          opacity: 0;
          pointer-events: none; /* 完全透明后不影响交互 */
        }
        .placeholder-img {
          width: 100%;
          height: auto;
          border-radius: 16px;
          filter: blur(15px);
          transition: filter 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }
      }
      .image-container {
        position: relative; // 相对定位，参与高度计算
        display: inline-block;
        max-width: 100%;
        height: auto;
        z-index: 1; /* 确保在模糊占位符下方 */
        transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        .img {
          display: block;
          position: relative; // 改为relative
          max-width: 100%; // 最大宽度100%
          // height: auto;
          height: 100%;
          border-radius: 16px;
          transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }
        .stop {
          width: 40px;
          height: 40px;
          background: rgba(44, 44, 44, 0.1);
          border-radius: 20px;
          backdrop-filter: blur(16.66666666666667px);
          -webkit-backdrop-filter: blur(10px) saturate(150%);
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: #ffffff;
          z-index: 3;
          .stopIcon {
            width: 28px;
            height: 28px;
          }
        }
      }
    }
    .isNone {
      width: 276px !important;
      height: 176px !important;
    }

    .load-fail {
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 16px;
      z-index: 3;
      @include useTheme {
        background: getVar('bg-color10-f4f6f8');
      }
      .failIcon {
        width: 64px;
        height: 64px;
      }
    }
  }

  .BoxFour {
    padding: 0 12px;
    border-radius: 10px;
    cursor: pointer;
    @include useTheme {
      border: 1px solid getVar('border-color2-f2f4f6');
    }
    .four {
      padding: 8px 0 8px 4px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      @include useTheme {
        box-shadow: inset 0px -1px 0px 0px getVar('border-color2-f2f4f6');
      }
      &:last-child {
        box-shadow: none !important;
      }
      .fourLeft {
        display: flex;
        align-items: center;
        margin-right: 8px;
        @include useTheme {
          color: getVar('text-color1-2c2c2c');
        }
        .btIcon {
          width: 20px;
          height: 20px;
        }
        .fourFont {
          font-weight: 400;
          font-size: 13px;
          line-height: 18px;
          margin-left: 8px;
          max-width: 492px;
          @include multiline(1);
          @include useTheme {
            color: getVar('text-color1-2c2c2c');
          }
        }
      }
      .rightIcon {
        width: 12px;
        height: 12px;
        @include useTheme {
          color: getVar('text-color3-90969c');
        }
      }
    }
  }
  .BoxFive {
    display: flex;

    .btBox {
      width: 189px;
      height: 52px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      .btIcon {
        width: 20px;
        height: 20px;
        @include useTheme {
          color: getVar('text-color2-75787b');
        }
      }

      .font4 {
        font-weight: 500;
        font-size: 13px;
        line-height: 18px;
        margin-left: 6px;
        @include useTheme {
          color: getVar('text-color2-75787b');
        }
      }

      .font5 {
        @include useTheme {
          color: getVar('primary-color') !important;
        }
      }
    }
  }
}

/* 其他样式保持不变 */
.load-more-trigger {
  height: 1px; /* 不可见元素，仅用于触发观察器 */
}
.loadStatus {
  padding: 32px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  .loadBox {
    display: flex;
    align-items: center;
    justify-content: center;
    .spinner {
      border: 3px solid rgba(5, 216, 196, 0.2);
      border-radius: 50%;
      width: 18px;
      height: 18px;
      animation: spin 1s linear infinite;
      margin-right: 10px;
      @include useTheme {
        border-top: 3px solid getVar('primary-color');
      }
    }
  }
  .not {
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    @include useTheme {
      color: getVar('text-color6-b8bec4');
    }
  }
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.img-placeholder {
  border-radius: 50%;
  width: 40px;
  height: 40px;
  overflow: hidden;
  position: relative;
  @include useTheme {
    background: getVar('bg-color1-f4f6f8');
  }
}

.skeleton-shine {
  position: absolute;
  top: 0;
  left: -100%;
  width: 50%;
  height: 100%;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.2) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  animation: shine 1.5s infinite;
}

@keyframes shine {
  to {
    left: 100%;
  }
}
</style>
